import { useCallback } from 'react'
import { useAjaxContext } from '../../../core/ajax'

export const useGlobalCalls = () => {
  const { get } = useAjaxContext()

  const getGlobals = useCallback(
    () =>
      new Promise((resolve) => {
        get('/configuracion')
          .then((response) => resolve(response))
          .catch(({ response }) => {
            console.error(response && response.data)
          })
      }),
    [] // eslint-disable-line
  )

  return {
    getGlobals,
  }
}
